import CollaboratorForm from './UserForm';

export default CollaboratorForm;
